import React from "react";
import {
  query,
  where,
  orderBy,
  collection,
  onSnapshot,
} from "firebase/firestore";

import { db } from "configs";
import { Utils } from "utils";
import { useAppDispatch } from "store";
import { IMember, Iterable } from "types";
import { COLLECTIONS } from "constants/firebase";
import { authMemberThunk, setRouteAuthMember } from "store/route-auth";

import { useToast } from "../use-toast";

export const useAuthMemberState = (email?: string) => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    const subscribe = email
      ? onSnapshot(
          query(
            collection(db, COLLECTIONS.MEMBERS),
            where("email", "==", email),
            orderBy("createdAt", "desc")
          ),
          (snapshot) => {
            console.log({ snapshot });
            if (!snapshot.empty) {
              const documents =
                Utils.Helpers.castDocs<Iterable<IMember>>(snapshot);

              if (documents.length > 0) {
                const member = documents[0];
                dispatch(setRouteAuthMember(member));
              }
            }
          }
        )
      : undefined;

    return () => {
      if (subscribe) subscribe();
    };
  }, [email, dispatch]);
};

export const useMemberEmail = () => {
  const dispatch = useAppDispatch();
  const { handleFirebaseError } = useToast();

  const [loading, setLoading] = React.useState(false);

  const authMember = React.useCallback(
    async (e: string) => {
      try {
        setLoading(true);
        await dispatch(authMemberThunk(e));
      } catch (error) {
        handleFirebaseError(error);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  React.useEffect(() => {
    Utils.IFrame.postGetEmail();

    const onMessage = (messageEvent: MessageEvent) => {
      Utils.IFrame.handleMessage(
        messageEvent,
        async (event) => {
          if (event.data.key === "storageEmail") {
            const { email = "" } = event.data ?? {};

            window.removeEventListener("message", onMessage);
            if (email) await authMember((email as string).toLowerCase());
          }
        },
        { origins: ["*"] }
      );
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading } as const;
};
